import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, TrendingUp } from "lucide-react";
import { Reveal, PlatformBadge } from "@/components/marketing/kit";
import { CASES } from "@/components/marketing/content";

export default function CaseStudies() {
  const nav = useNavigate();
  const [feat, ...rest] = CASES;
  return (
    <main>
      <section className="mk-sec" style={{ paddingBottom: 30 }}><div className="mk-wrap mk-head">
        <Reveal><span className="mk-pill"><TrendingUp size={14} /> Proof, not promises</span></Reveal>
        <Reveal delay={0.08}><h1 className="mk-h2" style={{ fontSize: "clamp(32px,4.6vw,56px)" }} data-testid="cases-title">Campaigns that turned creators into growth</h1></Reveal>
        <Reveal delay={0.16}><p data-testid="cases-description">Real outcomes from brands and agencies running their creator programs on HypeFlow AI.</p></Reveal>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <Reveal><div className="mk-case-feat" data-testid={`case-featured-${feat.slug}`} style={{ cursor: "pointer" }} onClick={() => nav(`/case-studies/${feat.slug}`)}>
          <div className="mk-case-feat-img"><img src={`${feat.cover}&w=900`} alt={feat.brand} /><div className="ov" /></div>
          <div className="mk-case-feat-body">
            <div className="brand"><i style={{ background: feat.logoColor }} /> {feat.brand} · {feat.industry}</div>
            <h2>{feat.headline}</h2>
            <p>{feat.summary}</p>
            <div className="mk-case-feat-stats">
              <div><b>{feat.metric}</b><small>{feat.metricLabel}</small></div>
              <div><b>{feat.roi}</b><small>return on spend</small></div>
              <div><b>{feat.creators}</b><small>creators</small></div>
            </div>
            <Link to={`/case-studies/${feat.slug}`} className="mk-btn primary" style={{ width: "max-content" }} data-testid="case-featured-read">Read the story <ArrowRight size={16} /></Link>
          </div>
        </div></Reveal>

        <div className="mk-case-grid">
          {rest.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 3) * 0.08}>
              <article className="mk-case-card" data-testid={`case-card-${c.slug}`} onClick={() => nav(`/case-studies/${c.slug}`)}>
                <div className="mk-case-card-img"><img src={`${c.cover}&w=600`} alt={c.brand} /><PlatformBadge platform={c.platform} /></div>
                <div className="mk-case-card-body">
                  <span className="brand">{c.brand} · {c.industry}</span>
                  <h3>{c.headline}</h3>
                  <p>{c.summary}</p>
                  <div className="mk-case-card-foot">
                    <div><b>{c.metric}</b><small>{c.metricLabel}</small></div>
                    <div><b>{c.roi}</b><small>ROI</small></div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap"><div className="mk-cta">
        <span className="mk-pill" style={{ margin: "0 auto" }}><Sparkles size={14} /> Your story next</span>
        <h2>Write your own success story</h2>
        <p>Start free and build a creator program you'll want to show off.</p>
        <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="cases-final-trial">Start free <ArrowRight size={17} /></Link><Link to="/contact" className="mk-btn ghost lg">Book a demo</Link></div>
      </div></div></section>
    </main>
  );
}
